/**
 * A usable case / patient id: route params and redux fields can hold
 * undefined, "" or the strings "undefined" / "null" when not loaded yet.
 */
export const isValidCaseRef = (value: unknown): value is string =>
  typeof value === "string" &&
  value.trim() !== "" &&
  value !== "undefined" &&
  value !== "null"

/** zip name without .zip ("bulk2") of a zip file name or path ("Setting/bulk2.zip") */
export const toZipBaseName = (key: string): string =>
  (key.split("/").pop() ?? "").replace(/\.zip$/, "")

/** zip names without .zip of the zips among server file names */
export const getZipBaseNames = (fileNames: string[]): string[] =>
  fileNames.filter((name) => name.endsWith(".zip")).map(toZipBaseName)

/**
 * Top-level folder each case zip wraps its files in. weDesign / uDesign desktop
 * check these folders exist after extraction ("Local case file is not
 * complete."), so every uploaded case zip must contain its folder, even empty.
 */
export const CASE_ZIP_FOLDERS: Readonly<Record<string, string>> = {
  bulk0: "Setting Data0",
  bulk1: "Setting Data1",
  bulk2: "Setting Data2",
  bulk10: "Setting Data10",
  raw: "Raw",
  photo: "Photo",
}
